export const FETCH_RECEPTACLE_REQUEST = 'FETCH_RECEPTACLE_REQUEST';
export const FETCH_RECEPTACLE_SUCCESS = 'FETCH_RECEPTACLE_SUCCESS';
export const FETCH_RECEPTACLE_FAILURE = 'FETCH_RECEPTACLE_FAILURE';
